import { useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Box, Button, Stack } from "@mui/material";
import CallEndIcon from "@mui/icons-material/CallEnd";

import ScreenContainer from "./ScreenContainer";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../../Actions/appActions";

import imageCalling from "../../../../../../Assets/StoryAgent/call_sam.png";

import Message from "../../../../../Commons/Message";

interface ScreenProps {
  transition: number;
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
  theme: Theme;
}

const Screen = (props: ScreenProps) => {
  const { transition, screen, setStory } = props;

  useEffect(() => {
    if (screen === 12 && transition === 2) setTimeout(() => setStory({ transition: transition + 1 }), 500);
    if (screen === 12 && transition === 3) setTimeout(() => setStory({ transition: transition + 1 }), 3000);
    if (screen === 12 && transition === 4) setTimeout(() => setStory({ transition: transition + 1, animating: false }), 1000);

    if (screen === 12 && transition === 6) setTimeout(() => setStory({ screen: screen + 1, transition: 2 }), 1500);

    return () => {};
  }, [transition, screen, setStory]);

  const propsMsgOne = useSpring({
    opacity: transition <= 2 ? 0 : 1,
    config: { duration: 600 },
  });

  const propsMsgTwo = useSpring({
    marginTop: "1.25em",
    opacity: transition <= 3 ? 0 : 1,
    config: { duration: 600 },
  });

  const propsBtn = useSpring({
    opacity: transition <= 4 ? 0 : 1,
    config: { duration: 600 },
  });

  const propsChat = useSpring({
    opacity: transition >= 6 ? 0 : 1,
    config: { duration: 600 },
  });

  const handleNextScreen = () => setStory({ transition: transition + 1 });

  return (
    <ScreenContainer height={"auto"}>
      <Box sx={{ width: "53.38541667em" }}>
        <Stack direction={"row"} sx={{ justifyContent: "center", alignItems: "flex-start", marginTop: "2.60416667em" }}>
          <animated.div style={{ ...styles.people }}>
            <img src={imageCalling} alt="" style={styles.imageCalling} />
          </animated.div>
          <animated.div style={{ marginLeft: "7.08333333em", flex: 1, ...propsChat }}>
            <animated.div style={{ ...propsMsgOne }}>
              <Message name={"Sam"} message={"Melissa I was able to locate only one of them. I can arrange for it to be sent across"} />
            </animated.div>
            <animated.div style={{ ...propsMsgTwo }}>
              <Message name={"Melissa"} message={"Hmm thank you for that. Speak soon"} />
            </animated.div>
            <animated.div style={{ ...propsBtn }}>
              <Button sx={styles.btn} onClick={handleNextScreen} variant="contained" endIcon={<CallEndIcon />}>
                End Call
              </Button>
            </animated.div>
          </animated.div>
        </Stack>
      </Box>
    </ScreenContainer>
  );
};

const styles = {
  topBox: {
    textAlign: "center" as "center",
    width: "100%",
  },
  text_1: {
    fontSize: "1.4583em",
    fontWeight: "bold",
  },
  boxText: {
    marginTop: "0.41666667em",
  },
  text_2: {
    fontSize: "1.25em",
  },
  people: {
    objectFit: "contain" as "contain",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    marginTop: "2.60416667em",
  },
  imageCalling: {
    width: "19.352vh",
  },
  btn: {
    marginTop: "2.1875em",
    textAlign: "left",
    justifycontent: "flex-start",
    display: "flex",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
    screen: state.appReducer.story.screen,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(Screen, mapStateToProps, mapDispatchToProps);
